import {
  call,
  put,
  takeEvery,
  takeLatest,
  cancel,
  select,
} from 'redux-saga/effects';
import { delay } from 'redux-saga';
import { initialize } from 'redux-form';
import moment from 'moment/moment';

import {
  REPORTS_TRANSACTIONS_PAGE_REQUEST,
  REPORTS_TRANSACTIONS_ISSUE_REFUND_REQUEST,
  REPORTS_TRANSACTIONS_TRANSACTION_DETAIL_REQUEST_NON_MOBILE,
  REPORTS_TRANSACTIONS_TRANSACTION_DETAIL_REQUEST_MOBILE,
  REPORTS_TRANSACTIONS_TRANSACTIONS_REQUEST,
  REPORTS_TRANSACTIONS_CHANGE_OUTLET,
  REPORTS_TRANSACTIONS_CHANGE_DATE,
  REPORTS_TRANSACTIONS_HIDE_TRANSACTION_DETAIL,
  REPORTS_TRANSACTIONS_SEND_EMAIL_RECEIPT,
  REPORTS_TRANSACTIONS_EXPORT_TRANSACTION,
  REPORTS_TRANSACTIONS_ISSUE_OLD_REFUND_REQUEST,
  REPORTS_TRANSACTIONS_CHANGE_KEYWORD,
  REPORTS_TRANSACTIONS_CONFIRM_SET_QUANTITY,
  REPORTS_TRANSACTIONS_CANCEL_SET_QUANTITY,
  REPORTS_TRANSACTIONS_ASK_SET_QUANTITY,
  REPORTS_TRANSACTIONS_CANCEL_RESEND_EMAIL,
  REPORTS_TRANSACTIONS_CANCEL_REFUND_BREAKDOWN,
} from '../../actions/reports/transactions/constants';
import { LOGOUT } from '../../actions/constants';
import {
  showProgressBar,
  hideProgressBar,
  sendingRequest,
} from '../../actions';
import { setCurrentOutlet } from '../../actions/outlet';
import {
  setTransactions,
  setTransactionDetail,
  getTransactionsRequest,
  hideResendEmailModal,
  hideTransactionDetail,
  showTransactionDetailModal,
  hideRefundBreakdownModal,
  hideTransactionDetailModal,
  hideOldRefundModal,
  setRefundItems,
  pageRequest,
  setOutlets,
  showSetQuantityModal,
  hideSetQuantityModal,
  setRefundItemsPromo,
} from '../../actions/reports/transactions';
import { setOrderDetail } from '../../actions/reports/transactionsv2';
import * as actActionBar from '../../actions/actionBar';
import * as actGetExportedFile from '../../actions/get-exported-file';
import { showPageLoadingSpinner } from '../../actions/loadingSpinner';
import * as actNotif from '../../actions/notifications';

import { postEmailReceipt } from '../../api/email-receipt';
import * as apiReport from '../../api/reports';
import * as apiOutlet from '../../api/outlets';
import * as apiPaymentConfig from '../../api/paymentConfiguration';
import getTransactionPaymentMethods from '../../selectors/getTransactionPaymentMethods';
import { DEFAULT_START_HOUR, DEFAULT_END_HOUR } from '../../utils/hourFilter';
import {
  getSelectedOutletIdFromLocalStorage,
  setSelectedOutletIdToLocalStorage,
} from '../../utils/selectedOutletId';
import {
  assertErrorHasMessage,
  assertErrorHasResponse,
} from '../../utils/assert';
import * as clevertapReportsTransactions from '../../clevertap/reports/transactions';
import { getFilteredDateAsMoment } from '../api/get-filtered-date';
import { getTransactions, getTransactionDetail } from '../api/report';
import { postRefund, postOldRefund } from '../api/refunds';

function* initForm(outletIds, startDate, endDate) {
  const allDay = moment(endDate).format('HH:mm') === '23:59';
  const startHour = !allDay
    ? moment(startDate).format('HH:mm')
    : DEFAULT_START_HOUR;
  const endHour = !allDay ? moment(endDate).format('HH:mm') : DEFAULT_END_HOUR;
  yield put(
    initialize('search', {
      outlet: outletIds,
      date: { startDate, endDate, startHour, endHour, allDay },
    })
  );
}

function* initResendEmailForm(transactionDetail) {
  yield put(initialize('resendEmailForm', { email: transactionDetail.email }));
}

function extractForRefundBreakdown(transactionDetail) {
  // extract for refund breakdown
  const refundAvailabilities = transactionDetail.refund_availability;
  const refundItems = {};
  refundAvailabilities.forEach((refundAvailability) => {
    // set necessary data for refund breakdown
    const item = {
      categoryId: refundAvailability.category_id,
      categoryName: refundAvailability.category_name,
      discountPerItem: refundAvailability.discount_per_item,
      redemptionPerItem: refundAvailability.redemption_per_item,
      discounts: refundAvailability.discounts,
      itemId: refundAvailability.item_id,
      itemName: refundAvailability.item_name,
      itemImage: refundAvailability.item_image,
      itemVariantId: refundAvailability.item_variant_id,
      itemVariantName: refundAvailability.item_variant_name,
      itemVariantSku: refundAvailability.item_variant_sku,
      gratuityPerItem: refundAvailability.gratuity_per_item,
      grossPerItem: refundAvailability.gross_per_item,
      modifiers: refundAvailability.modifiers,
      gratuities: refundAvailability.gratuities,
      taxPerItem: refundAvailability.tax_per_item,
      trackStock: refundAvailability.track_stock,
      parentCheckoutId: refundAvailability.parent_checkout_id,
      parentCheckoutUuid: refundAvailability.parent_checkout_uuid,
      pricePerItem: refundAvailability.price_per_item,
      netPerItem: refundAvailability.net_per_item,
      position: refundAvailability.position,
      salesTypeId: refundAvailability.sales_type_id,
      salesTypeName: refundAvailability.sales_type_name,
      // max quantity is maximum amount that can be refunded
      maxQuantity: refundAvailability.quantity,
      // is refunded is whether the item is included as refunded item.
      // if 0, it can't be refunded and must be excluded
      isRefunded: refundAvailability.quantity > 0,
      // default value is quantity if can be refunded
      refundAmount:
        refundAvailability.quantity > 0 ? refundAvailability.quantity : 0,
    };
    if (refundItems[item.salesTypeName]) {
      refundItems[item.salesTypeName].push(item);
    } else {
      refundItems[item.salesTypeName] = [];
      refundItems[item.salesTypeName].push(item);
    }
  });
  return refundItems;
}

function constructRefundItemsPromo(transactionDetail, refundItems) {
  if (transactionDetail.promos) {
    const refundItemsPromo: any[] = [];
    let promoChecked = false;
    transactionDetail.promos.forEach((promo) => {
      promo.items.forEach((item) => {
        // eslint-disable-next-line guard-for-in
        for (const salesType in refundItems) {
          // eslint-disable-next-line @typescript-eslint/no-loop-func
          refundItems[salesType].forEach((refundItem) => {
            if (refundItem.parentCheckoutUuid === item.checkout_uuid) {
              promoChecked = refundItem.isRefunded;
            }
          });
        }
      });

      const object = {
        ...promo,
        isChecked: promoChecked,
      };
      refundItemsPromo.push(object);
    });
    return refundItemsPromo;
  }
}

function insensitive(s1, s2) {
  const s1lower = s1.toLowerCase();
  const s2lower = s2.toLowerCase();
  // eslint-disable-next-line no-nested-ternary
  return s1lower > s2lower ? 1 : s1lower < s2lower ? -1 : 0;
}

function sortCheckouts(checkouts) {
  const sortedSt = {};
  const sortedNoSt = {};
  let key;
  const a: any[] = [];
  for (key in checkouts) {
    if (Object.prototype.hasOwnProperty.call(checkouts, key)) {
      a.push(key);
    }
  }
  a.sort(insensitive);
  for (key = 0; key < a.length; key++) {
    if (a[key] !== 'No Sales Type') {
      sortedSt[a[key]] = checkouts[a[key]];
    } else {
      sortedNoSt[a[key]] = checkouts[a[key]];
    }
  }
  return Object.assign(sortedSt, sortedNoSt);
}

/** ******************************************************************************
 * Transactions
 ******************************************************************************* */
export function* getAllPaymentMethods(query?) {
  yield put(sendingRequest(true));
  try {
    return yield call(apiPaymentConfig.getAllPaymentMethods, query);
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
    return [];
  } finally {
    yield put(sendingRequest(false));
  }
}

export function* pageRequestFlow() {
  // initialize transactions
  const transactionPayload = {
    transactions: null,
    netSales: null,
    totalCollected: null,
    totalTransactions: null,
  };

  // Dynamic Disable Refund - Get transactions to check if refund is allowed
  let paymentMethods = yield select(getTransactionPaymentMethods);
  if (paymentMethods.length === 0) {
    paymentMethods = yield call(getAllPaymentMethods);
  }
  (transactionPayload as any).paymentMethods = paymentMethods;

  yield put(setTransactions(transactionPayload));
  yield put(showPageLoadingSpinner(true));
  yield put(setTransactionDetail(null));

  const outletIds = getSelectedOutletIdFromLocalStorage();
  yield put(actActionBar.setSelectedOutletIds(outletIds));

  // set outlets
  const resOutlets = yield call(apiOutlet.outlets);
  yield put(setOutlets(resOutlets.data));
  yield put(actActionBar.setOutlets(resOutlets.data));

  const { startDate, endDate } = yield call(getFilteredDateAsMoment);
  const formattedStartDate = startDate.format('D/M/YYYY HH:mm:ss');
  const formattedEndDate = endDate.format('D/M/YYYY HH:mm:ss');

  yield call(
    initForm,
    getSelectedOutletIdFromLocalStorage(),
    startDate,
    endDate
  );

  yield put(
    getTransactionsRequest({ start: formattedStartDate, end: formattedEndDate })
  );

  clevertapReportsTransactions.reportsTransactionsStart({
    outletIds,
    startDate,
    endDate,
  });
  // animate scroll to top
  $('#transaction-table-list').animate({ scrollTop: 0 }, 'slow');
}

export function* transactionsFlow(request) {
  yield put(showPageLoadingSpinner(true));
  const { query } = request.payload;
  const result = yield call(getTransactions, query);
  if (result) {
    yield put(
      setTransactions({
        transactions: result.transactions,
        netSales: result.net_sales,
        totalCollected: result.total_collected,
        totalTransactions: result.total_transactions,
      })
    );
  }
  yield put(showPageLoadingSpinner(false));
}

/** ******************************************************************************
 * End Transactions
 ******************************************************************************* */

/** ******************************************************************************
 * Refund Breakdown
 ******************************************************************************* */

export function* issueRefundFlow(request) {
  const { data } = request.payload;
  yield call(postRefund, data);
  yield put(hideRefundBreakdownModal());
  yield put(hideTransactionDetailModal());
  yield put(hideTransactionDetail());
  yield put(pageRequest());
}

export function* askSetQuantity(request) {
  const {
    payload: { refundItemsIdx, salesTypeName, refundAmount },
  } = request;
  yield put(
    initialize('setQuantity', {
      idx: refundItemsIdx,
      salesTypeName,
      quantity: refundAmount,
    })
  );
  yield put(showSetQuantityModal());
}

export function* confirmSetQuantity(request) {
  const {
    payload: { refundItems },
  } = request;
  yield put(setRefundItems(refundItems));
  yield put(hideSetQuantityModal());
  yield put(initialize('setQuantity', { idx: null, quantity: null }));
}

export function* cancelSetQuantity() {
  yield put(hideSetQuantityModal());
  yield put(initialize('setQuantity', { idx: null, quantity: null }));
}

/** ******************************************************************************
 * End Refund Breakdown
 ******************************************************************************* */

/** ******************************************************************************
 * Old Refund
 ******************************************************************************* */

export function* issueOldRefundFlow(request) {
  const { data } = request.payload;
  yield call(postOldRefund, data);
  yield put(hideOldRefundModal());
  yield put(hideTransactionDetailModal());
  yield put(hideTransactionDetail());
  yield put(pageRequest());
}

/** ******************************************************************************
 * End Old Refund
 ******************************************************************************* */

/** ******************************************************************************
 * Change Handler
 ******************************************************************************* */

export function* changeOutletFlow(request) {
  yield put(
    setTransactions({
      transactions: null,
      netSales: null,
      totalCollected: null,
      totalTransactions: null,
    })
  );
  yield put(showPageLoadingSpinner(true));
  yield put(hideTransactionDetail());
  const { outletIds } = request.payload;
  setSelectedOutletIdToLocalStorage(outletIds);
  const currentOutlet = yield call(apiOutlet.outlets, { ids: outletIds[0] });
  yield put(setCurrentOutlet(currentOutlet));

  const { startDate, endDate } = yield call(getFilteredDateAsMoment);
  yield call(initForm, outletIds, startDate, endDate);
  const formattedStartDate = startDate.format('D/M/YYYY HH:mm:ss');
  const formattedEndDate = endDate.format('D/M/YYYY HH:mm:ss');
  yield put(
    getTransactionsRequest({ start: formattedStartDate, end: formattedEndDate })
  );
}

export function* changeDateFlow(request) {
  yield put(
    setTransactions({
      transactions: null,
      netSales: null,
      totalCollected: null,
      totalTransactions: null,
    })
  );
  yield put(showPageLoadingSpinner(true));
  yield put(hideTransactionDetail());
  const { startDate, endDate } = request.payload;
  yield put(getTransactionsRequest({ start: startDate, end: endDate }));
}

export function* changeKeywordFlow(request) {
  yield put(
    setTransactions({
      transactions: null,
      netSales: null,
      totalCollected: null,
      totalTransactions: null,
    })
  );
  yield put(showPageLoadingSpinner(true));
  yield put(hideTransactionDetail());
  const { keyword, startDate, endDate } = request.payload;
  let filterTotalTransactions = 0;
  let filterTotalCollected = 0;
  let filterNetSales = 0;
  const filterResult: any[] = [];
  let transRes;

  yield delay(300, true);
  try {
    yield put(showProgressBar());

    const query = { start: startDate, end: endDate };
    transRes = yield call(apiReport.getTransactions, query);
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  } finally {
    yield put(hideProgressBar());
  }
  if (transRes.data) {
    const { data } = transRes;
    const regexTransaction = new RegExp(keyword, 'i');

    data.transactions.forEach((transPayment) => {
      const paymentArray: any[] = [];
      let perDateTotalCollected = 0;

      transPayment.payments.forEach((transaction) => {
        if (transaction.payment_no.match(regexTransaction)) {
          if (!transaction.is_refunded) {
            filterTotalTransactions += 1;
          }
          perDateTotalCollected += transaction.total_collected_report;
          filterNetSales += transaction.net_sales_report;
          paymentArray.push(transaction);
        }
      });

      if (paymentArray.length > 0) {
        filterTotalCollected += perDateTotalCollected;
        const trxPerDate = {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          date_label: transPayment.date_label,
          // eslint-disable-next-line @typescript-eslint/naming-convention
          total_collected: perDateTotalCollected,
          payments: paymentArray,
        };
        filterResult.push(trxPerDate);
      }
    });
    const ts = {
      transactions: filterResult,
      totalTransactions: filterTotalTransactions,
      totalCollected: filterTotalCollected,
      netSales: filterNetSales,
    };
    yield put(setTransactions(ts));
  }
  yield put(showPageLoadingSpinner(false));
}
/** ******************************************************************************
 * End Change Handler
 ******************************************************************************* */

/** ******************************************************************************
 * Transaction Detail Flow
 ******************************************************************************* */
export function* transactionDetailMobileFlow(request) {
  const { id, query } = request.payload;
  const transactionDetail = yield call(getTransactionDetail, id, query);
  const { startDate, endDate } = yield call(getFilteredDateAsMoment);
  transactionDetail.outlet_ids = getSelectedOutletIdFromLocalStorage();
  transactionDetail.start_date = startDate;
  transactionDetail.end_date = endDate;
  clevertapReportsTransactions.reportsTransactionsSelect({
    transactionDetail,
  });
  yield put(setTransactionDetail(transactionDetail));
  yield call(initResendEmailForm, transactionDetail);

  const refundItems = extractForRefundBreakdown(transactionDetail);
  yield put(setRefundItems(refundItems));

  const refundItemsPromo = constructRefundItemsPromo(
    transactionDetail,
    refundItems
  );
  yield put(setRefundItemsPromo(refundItemsPromo));

  yield put(showTransactionDetailModal());
}

export function* transactionDetailNonMobileFlow(request) {
  const { id, query } = request.payload;
  const transactionDetail = yield call(getTransactionDetail, id, query);
  const { checkouts } = transactionDetail;
  const sorted = sortCheckouts(checkouts);
  transactionDetail.checkouts = null;
  transactionDetail.checkouts = sorted;
  for (let i = 0; i < transactionDetail.payment_refunds.length; i++) {
    const checkoutsRefund = transactionDetail.payment_refunds[i].checkouts;
    const sortedCheckouts = sortCheckouts(checkoutsRefund);
    transactionDetail.payment_refunds[i].checkouts = null;
    transactionDetail.payment_refunds[i].checkouts = sortedCheckouts;
  }
  /**
   * add Current Selected Outlet, Current Time Filter Start, Current Time Filter End
   * into Clevertap tracking
   */
  const { startDate, endDate } = yield call(getFilteredDateAsMoment);
  transactionDetail.outlet_ids = getSelectedOutletIdFromLocalStorage();
  transactionDetail.start_date = startDate;
  transactionDetail.end_date = endDate;
  clevertapReportsTransactions.reportsTransactionsSelect({
    transactionDetail,
  });
  yield put(setTransactionDetail(transactionDetail));
  yield call(initResendEmailForm, transactionDetail);

  const refundItems = extractForRefundBreakdown(transactionDetail);
  yield put(setRefundItems(refundItems));

  const refundItemsPromo = constructRefundItemsPromo(
    transactionDetail,
    refundItems
  );
  yield put(setRefundItemsPromo(refundItemsPromo));

  // animate
  if ($('#mk-col-left').hasClass('col-sm-12')) {
    $('#mk-col-left, #mk-col-right').toggleClass('col-sm-12 col-md-6 col-xs-6');
    setTimeout(() => {
      $('#mk-col-right').fadeIn(200);
      $('[data-toggle="popover"]').popover();
    }, 600);
  }
}

export function* hideTransactionDetailFlow() {
  yield put(setTransactionDetail(null));
  yield put(setOrderDetail(null));
  // animation
  const toggledClass = 'col-sm-12 col-md-6 col-xs-6';
  $('#mk-col-left, #mk-col-right').removeClass(toggledClass);
  $('#mk-col-left').addClass('col-sm-12');
}

/** ******************************************************************************
 * End Transaction Detail Flow
 ******************************************************************************* */

/** ******************************************************************************
 * Export Transaction Flow
 ******************************************************************************* */

export function* exportTransactionFlow(request) {
  // noinspection JSUnresolvedVariable
  const { params } = request.payload;
  const { query, filename, outlet, reportType } = params;
  try {
    if (reportType === 'item') {
      // export transactions by item
      yield call(apiReport.exportTransactionByItem, query);
    } else {
      yield call(apiReport.exportTransaction, query);
    }
    // fetch the result
    yield put(
      actGetExportedFile.getExportedFile(filename, outlet[0], 'Transaction')
    );
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  }
}

/** ******************************************************************************
 * End Export Transaction Flow
 ******************************************************************************* */

/** ******************************************************************************
 * Resend Email
 ******************************************************************************* */

export function* sendEmailReceiptFlow(request) {
  const query = request.payload.data;
  try {
    const response = yield call(postEmailReceipt, query);
    yield put(actNotif.success(response.data.message));
    clevertapReportsTransactions.reportsTransactionsResendReceipt();
  } catch (error) {
    assertErrorHasResponse(error);
    const { response } = error;
    yield put(actNotif.error(response.data.message));
  } finally {
    yield put(hideResendEmailModal());
  }
}

export function* cancelResendEmail(request) {
  const {
    payload: { transactionDetail },
  } = request;
  yield call(initResendEmailForm, transactionDetail);
  yield put(hideResendEmailModal());
}

export function* cancelRefundBreakdown(request) {
  const {
    payload: { transactionDetail },
  } = request;
  const refundItems = extractForRefundBreakdown(transactionDetail);
  yield put(setRefundItems(refundItems));

  const refundItemsPromo = constructRefundItemsPromo(
    transactionDetail,
    refundItems
  );
  yield put(setRefundItemsPromo(refundItemsPromo));

  yield put(hideRefundBreakdownModal());
}

/** ******************************************************************************
 * End Resend Email
 ******************************************************************************* */

export function* cancelAction(cancelledTasks) {
  yield cancel(...cancelledTasks);
}

export default function* reportsTransactionsSaga() {
  const pageReqTask = yield takeLatest(
    REPORTS_TRANSACTIONS_PAGE_REQUEST,
    pageRequestFlow
  );
  const transDetailNonMobTask = yield takeLatest(
    REPORTS_TRANSACTIONS_TRANSACTION_DETAIL_REQUEST_NON_MOBILE,
    transactionDetailNonMobileFlow
  );
  const transDetailMobTask = yield takeLatest(
    REPORTS_TRANSACTIONS_TRANSACTION_DETAIL_REQUEST_MOBILE,
    transactionDetailMobileFlow
  );
  const transTask = yield takeLatest(
    REPORTS_TRANSACTIONS_TRANSACTIONS_REQUEST,
    transactionsFlow
  );
  const changeOutletTask = yield takeLatest(
    REPORTS_TRANSACTIONS_CHANGE_OUTLET,
    changeOutletFlow
  );
  const changeDateTask = yield takeLatest(
    REPORTS_TRANSACTIONS_CHANGE_DATE,
    changeDateFlow
  );
  yield takeEvery(
    REPORTS_TRANSACTIONS_HIDE_TRANSACTION_DETAIL,
    hideTransactionDetailFlow
  );
  const sendEmailReceiptTask = yield takeEvery(
    REPORTS_TRANSACTIONS_SEND_EMAIL_RECEIPT,
    sendEmailReceiptFlow
  );
  const issueRefundTask = yield takeLatest(
    REPORTS_TRANSACTIONS_ISSUE_REFUND_REQUEST,
    issueRefundFlow
  );
  const exportTransTask = yield takeLatest(
    REPORTS_TRANSACTIONS_EXPORT_TRANSACTION,
    exportTransactionFlow
  );
  const issueOldRefundTask = yield takeLatest(
    REPORTS_TRANSACTIONS_ISSUE_OLD_REFUND_REQUEST,
    issueOldRefundFlow
  );
  const changeKeywordTask = yield takeLatest(
    REPORTS_TRANSACTIONS_CHANGE_KEYWORD,
    changeKeywordFlow
  );

  yield takeLatest(REPORTS_TRANSACTIONS_ASK_SET_QUANTITY, askSetQuantity);
  yield takeLatest(
    REPORTS_TRANSACTIONS_CONFIRM_SET_QUANTITY,
    confirmSetQuantity
  );
  yield takeLatest(REPORTS_TRANSACTIONS_CANCEL_SET_QUANTITY, cancelSetQuantity);
  yield takeLatest(REPORTS_TRANSACTIONS_CANCEL_RESEND_EMAIL, cancelResendEmail);
  yield takeLatest(
    REPORTS_TRANSACTIONS_CANCEL_REFUND_BREAKDOWN,
    cancelRefundBreakdown
  );

  yield takeEvery(LOGOUT, cancelAction, [
    pageReqTask,
    transDetailNonMobTask,
    transDetailMobTask,
    transTask,
    issueRefundTask,
    exportTransTask,
    changeOutletTask,
    changeDateTask,
    sendEmailReceiptTask,
    issueOldRefundTask,
    changeKeywordTask,
  ]);
}
